/* nsh-quiz-fb.js — 피부 리딩 결과 화면 안에서 피드백 받기 (2026-10-01, v12.7)
   1) 「혹시, 읽고도 풀리지 않은 질문이 있나요?」 섹션: 3번 「더 알아보기」 다음에 붙는다.
      이메일을 남겨 전체가 열린 본인 결과에서만 보인다. 질문은 질문함 시트(Apps Script 웹앱)로 간다.
   2) 「다시하기」를 누르면 이유 셋이 펼쳐지고, 고르면 이유를 남긴 뒤 처음 화면으로 간다.
   결과 화면은 v12.js 의 render() 가 #nshV9 를 통째로 다시 그린다. 그때마다 다시 붙인다
   (#result · #nshV9 의 직계 자식 변화만 지켜본다).
   한국어·영어·일본어 화면 모두 켠다(로케일은 주소 앞자리 /ko · /ja, 그 밖은 영어 — track.js 와 같은 규칙).
   이메일은 다시 묻지 않는다. 게이트에서 남긴 주소를 브라우저에 기억해 두었다가 함께 보내고, 기억된 것이 없으면
   비워 보낸다(질문함의 방문 번호로 퀴즈 트래킹 시트의 waitlist_join 줄과 잇는다).
   보내는 주소는 스니펫의 window.NSH_ASK_URL. 비어 있으면 화면만 보이고 아무 데도 보내지 않는다.
   기록: fb_ask {state, concern, len} · fb_redo {reason, state} — 질문 글과 이메일은 logEvent 로 보내지 않는다. */
(function(){
  if (window.__NSH_FB) return; window.__NSH_FB = 1;
  var LOC = /^\/ko(\/|$)/.test(location.pathname) ? 'ko' : (/^\/ja(\/|$)/.test(location.pathname) ? 'ja' : 'en');
  var W = window, D = document;

  var TT = {
    ko: {
      askQ: '혹시, 읽고도 <span class="nsh-nw">풀리지 않은</span> 질문이 있나요?',
      askPromise: '사소한 것이라도 괜찮아요.',
      askPh: '예) 2주 동안 메이크업은 해도 되나요?',
      askAria: '읽고도 풀리지 않은 질문',
      askBtn: '질문 보내기',
      askSmall: '답은 남겨주신 이메일로 보내드려요. 며칠 걸릴 수 있어요.',
      sentH: '질문이 잘 제출되었습니다.',
      sent: '남겨주신 이메일로 답해드릴게요.',
      redoQ: '다시 하는 이유가 있나요?',
      redoHelp: '아래 보기를 선택하면 처음 화면으로 돌아가서 다시 시작할 수 있어요.',
      redoO: ['답을 잘못 골랐어요', '결과가 나와 달라요', '그냥 다시 할게요']
    },
    en: {
      askQ: 'Still have a question <span class="nsh-nw">after reading?</span>',
      askPromise: 'No question is too small.',
      askPh: 'e.g. Can I wear makeup during these two weeks?',
      askAria: 'Your question',
      askBtn: 'Send question',
      askSmall: 'We\'ll reply to the email you left with us. It may take a few days.',
      sentH: 'Your question has been sent.',
      sent: 'We\'ll reply to the email you left with us.',
      redoQ: 'Any reason for starting over?',
      redoHelp: 'Choose one below to go back to the first screen and start again.',
      redoO: ['I picked the wrong answer', 'This isn\'t my skin', 'Just starting over']
    },
    ja: {
      askQ: '読んでも<span class="nsh-nw">解けなかった</span>疑問はありますか？',
      askPromise: 'どんな小さなことでも大丈夫です。',
      askPh: '例）この2週間、メイクはしても大丈夫ですか？',
      askAria: '読んでも解けなかった疑問',
      askBtn: '質問を送る',
      askSmall: 'お返事は、残していただいたメールアドレスにお送りします。数日かかることがあります。',
      sentH: '質問を受け付けました。',
      sent: '残していただいたメールアドレスにお返事します。',
      redoQ: 'やり直す理由はありますか？',
      redoHelp: '下から選ぶと最初の画面に戻り、もう一度始められます。',
      redoO: ['答えを選び間違えました', '結果が自分と違います', '特に理由はありません']
    }
  };
  var RK = ['wrong_answer', 'not_me', 'just'];
  var T = TT[LOC];
  var EKEY = 'nshAskEmail';

  function $(s, r) { return (r || D).querySelector(s); }
  function log(n, p) { try { if (typeof W.logEvent === 'function') W.logEvent(n, p || {}); } catch (e) {} }
  function lsGet(k) { try { return W.localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { W.localStorage.setItem(k, v); } catch (e) {} }
  function sid() { try { return (JSON.parse(W.sessionStorage.getItem('nshAttr') || 'null') || {}).sid || ''; } catch (e) { return ''; } }
  function stateKey() { try { return (W.__wl && W.__wl.slug) || ''; } catch (e) { return ''; } }
  function el(tag, cls, html) { var e = D.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  /* 이메일 칸을 낼 때 주소를 기억해 둔다(메일로 답하려면 필요하다). */
  D.addEventListener('submit', function (ev) {
    try {
      var f = ev.target;
      if (!f || f.id !== 'waitForm') return;
      var i = f.querySelector('input[type=email]');
      var v = i && String(i.value || '').trim();
      if (v && validEmail(v)) lsSet(EKEY, v);
    } catch (e) {}
  }, true);

  /* ───── 질문 섹션 ───── */
  function ownerOpen(root) {
    var gated = $('.v9-gated', root);
    if (!gated || gated.classList.contains('on')) return false;        // 잠긴 화면
    if (!$('.v9-lede', root)) return false;                              // 상태 일반형(남의 링크)
    if ($('#v9ctaSlot #sharedCta', root)) return false;                  // 공유받은 화면
    if (D.body.classList.contains('shared-view')) return false;
    return true;
  }

  function buildAsk(root) {
    var notes = $('.v9-notes', root);
    if (!notes || $('.nsh-ask', root)) return;
    var sec = el('section', 'v9-rx nsh-ask');
    var st = ($('.v9-title', root) || {}).textContent || '';
    var cn = Array.prototype.map.call(root.querySelectorAll('.v9-cname'), function (x) { return x.textContent; }).join(' · ');

    sec.appendChild(el('h3', 'v9-shead nsh-ask-h', '<span class="nsh-ask-t">' + T.askQ + '</span>'));
    var body = el('div', 'nsh-ask-body');
    body.appendChild(el('p', 'nsh-p', T.askPromise));
    var form = el('form', 'nsh-ask-form');
    form.setAttribute('novalidate', '');
    var ta = el('textarea', 'nsh-ask-q');
    ta.name = 'q'; ta.maxLength = 1000; ta.rows = 4; ta.placeholder = T.askPh;
    ta.setAttribute('aria-label', T.askAria);
    form.appendChild(ta);
    var hp = el('input', 'nsh-hp');
    hp.type = 'text'; hp.name = 'company'; hp.tabIndex = -1; hp.autocomplete = 'off'; hp.setAttribute('aria-hidden', 'true');
    form.appendChild(hp);
    var btn = el('button', 'nsh-ask-btn', T.askBtn);
    btn.type = 'submit'; btn.disabled = true;
    form.appendChild(btn);
    form.appendChild(el('p', 'nsh-small', T.askSmall));
    body.appendChild(form);
    sec.appendChild(body);

    function check() { btn.disabled = !ta.value.trim(); }
    ta.addEventListener('input', check);

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var q = ta.value.trim();
      var email = lsGet(EKEY);   // 게이트에서 남긴 주소. 없으면 비워 보내고, 시트의 방문 번호로 가입 기록과 잇는다
      if (!q) return;
      var payload = {
        q: q, email: email, state: st, concern: cn, locale: LOC,
        url: location.href, sid: sid(), hp: hp.value
      };
      var url = W.NSH_ASK_URL || '';
      if (url) {
        try {
          var json = JSON.stringify(payload);
          if (!(navigator.sendBeacon && navigator.sendBeacon(url, new Blob([json], { type: 'text/plain;charset=UTF-8' })))) {
            fetch(url, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: json }).catch(function () {});
          }
        } catch (e) {}
      } else {
        try { console.warn('[fb] NSH_ASK_URL 이 비어 있어 질문을 보내지 않았습니다'); } catch (e) {}
      }
      log('fb_ask', { state: stateKey(), concern: cn, len: q.length, sent: url ? 1 : 0 });
      body.innerHTML = '';
      body.appendChild(el('p', 'nsh-p', T.sentH));
      body.appendChild(el('p', 'nsh-p nsh-p2', T.sent));
    });

    notes.parentNode.insertBefore(sec, notes.nextSibling);
  }

  /* ───── 다시하기 ───── */
  function goRestart() {
    try { W.restart(); } catch (e) { location.href = location.pathname; }
  }

  function buildRedo(root) {
    var old = $('#v9redo', root), row = $('.v9-row', root);
    if (!old || !row || old.getAttribute('data-nsh-fb')) return;
    var btn = old.cloneNode(true);                 // render() 가 붙인 곧장 돌아가는 동작을 떼어 낸다
    btn.setAttribute('data-nsh-fb', '1');
    btn.setAttribute('aria-expanded', 'false');
    old.parentNode.replaceChild(btn, old);

    var box = el('div', 'nsh-redo');
    box.id = 'nshRedo';
    box.hidden = true;
    btn.setAttribute('aria-controls', 'nshRedo');
    box.appendChild(el('h4', 'nsh-redo-q', T.redoQ));
    box.appendChild(el('p', 'nsh-small nsh-redo-help', T.redoHelp));
    var opts = el('div', 'nsh-redo-opts');
    T.redoO.forEach(function (label, i) {
      var b = el('button', 'nsh-redo-o', label);
      b.type = 'button';
      b.addEventListener('click', function () {
        log('fb_redo', { reason: RK[i], state: stateKey() });
        setTimeout(goRestart, 60);
      });
      opts.appendChild(b);
    });
    box.appendChild(opts);
    row.parentNode.insertBefore(box, row.nextSibling);

    btn.addEventListener('click', function () {
      var open = box.hidden;
      box.hidden = !open;
      btn.classList.toggle('nsh-on', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function apply() {
    var root = $('#nshV9');
    if (!root || !root.childElementCount) return;
    try { buildRedo(root); } catch (e) {}
    try { if (ownerOpen(root)) buildAsk(root); } catch (e) {}
  }

  /* render() 가 #nshV9 안을 갈아끼울 때만 다시 붙인다. 깊은 곳(subtree)은 보지 않는다. */
  var watched = null, t = null;
  function soon() { clearTimeout(t); t = setTimeout(apply, 30); }
  function watchV9() {
    var v9 = $('#nshV9');
    if (v9 && v9 !== watched) {
      watched = v9;
      try { new MutationObserver(soon).observe(v9, { childList: true }); } catch (e) {}
      soon();
    }
  }
  function init() {
    var res = $('#result');
    if (!res) return;
    try { new MutationObserver(watchV9).observe(res, { childList: true }); } catch (e) {}
    watchV9();
    /* 잠김이 풀리는 것은 클래스만 바뀌는 경우가 있어, 결과 영역의 class 변화도 한 번씩 본다 */
    try { new MutationObserver(soon).observe(res, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
